import React from 'react';

const QuestLayout = props => <div style={{ marginTop: '60px' }}>{props.children}</div>;
export default QuestLayout;
